var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconPrevious = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.06 10 2 5.954m0 0L4.999 2M2 5.954l23 .1",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "square"
})));

export default SvgIconPrevious;